import React from 'react';
import { Icon } from '@upsales/components';

type Props = {
	reached: boolean;
	className?: string;
	space?: string;
};

const PhoneStatusIndicator: React.FC<Props> = ({ reached, className, space = 'mrs' }) => {
	const iconName = reached ? 'phone-success' : 'phone-fail';
	const iconColor = reached ? 'medium-green' : 'red';

	return (
		<Icon 
			name={iconName} 
			color={iconColor} 
			space={space}
			className={className}
		/>
	);
};

export default PhoneStatusIndicator;